import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AiOutlineArrowUp } from 'react-icons/ai';
import homeStoryImg from '../../../assets/img/our-story.png';
import Button from '../../UI/Button/Button';
import './HomeOurStory.css';
import LanguageContext from '../../../context/LanguageContext.js';

const HomeOurStory = () => {
    const { dir } = useContext(LanguageContext);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const currentLanguage = i18n.language;

    return (
        <section
            className="section home-story-section section--surface-1"
            id="our-story"
            aria-labelledby="home-story-title"
        >
            <div className="container home-story-grid" dir={dir()}>
                <div className="home-story-content">
                    <p className="home-story-eyebrow">{t('home.ourStoryLabel')}</p>
                    <h2 id="home-story-title" className="section-title home-story-title">
                        <span className="home-story-title-line">{t('home.ourStoryTitleLine1')}</span>
                        <span className="home-story-title-accent">{t('home.ourStoryTitleLine2')}</span>
                    </h2>
                    <p className="home-story-body">{t('home.ourStoryBody')}</p>
                    <Button
                        flex
                        className="home-story-cta"
                        onClick={() => navigate(`/${currentLanguage}/menu`)}
                    >
                        {t('home.exploreMenu')}
                        <AiOutlineArrowUp className="arrow-up-next" aria-hidden="true" />
                    </Button>
                </div>
                <figure className="home-story-visual">
                    <div className="home-story-frame">
                        <img
                            src={homeStoryImg}
                            alt={t('home.ourStoryImageAlt')}
                            className="home-story-img"
                            width={640}
                            decoding="async"
                        />
                    </div>
                </figure>
            </div>
        </section>
    );
};

export default HomeOurStory;
